module.exports = __webpack_public_path__ + "e44e96e0b864e4952d6fb2ad102a78f9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/assets/ortho_icon.svg
 ** module id = 642
 ** module chunks = 0
 **/